import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { filterPublications } from './helpers';

import {
    getCountries,
    changeCountry,
    getStatesByCountry,
    changeState,
    getDocumentsByPublication,
    getSectionsByDocument,
    changePublication,
    changeDocument,
    getSectionDetails,
    loadSectionList,
    updateTreeData,
    registerMasterCourse,
    changeCurriculumType,
    getPublications
} from './actions';

import {
    GLOBAL_CURRICULUM_ID,
    COUNTRY_CURRICULUM_ID
} from '../../constants';

import CurriculumList from '../../components/curriculum-list/index';

class CurriculumListContainer extends PureComponent {
    static propTypes = {
        changeCountry: PropTypes.func,
        changeDocument: PropTypes.func,
        changePublication: PropTypes.func,
        changeState: PropTypes.func,
        changeCurriculumType: PropTypes.func,
        countries: PropTypes.array,
        countryLoaded: PropTypes.bool,
        currentView: PropTypes.string,
        curriculumType: PropTypes.string,
        documents: PropTypes.array,
        getCountries: PropTypes.func,
        getPublications: PropTypes.func,
        getDocumentsByPublication: PropTypes.func,
        getSectionsByDocument: PropTypes.func,
        getSectionDetails: PropTypes.func,
        getStatesByCountry: PropTypes.func,
        loadSectionList: PropTypes.func,
        publications: PropTypes.array,
        registerMasterCourse: PropTypes.func,
        sections: PropTypes.array,
        selectedCountry: PropTypes.string,
        selectedDocument: PropTypes.string,
        selectedPublication: PropTypes.string,
        selectedSectionDetail: PropTypes.object,
        selectedState: PropTypes.string,
        states: PropTypes.array,
        updateTreeData: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.handleCurriculumTypeOnChange = this.handleCurriculumTypeOnChange.bind(this);
        this.handleCountryOnChange = this.handleCountryOnChange.bind(this);
        this.handleStateOnChange = this.handleStateOnChange.bind(this);
        this.handlePublicationOnChange = this.handlePublicationOnChange.bind(this);
        this.handleDocumentOnChange = this.handleDocumentOnChange.bind(this);
        this.handleOnSectionNameClick = this.handleOnSectionNameClick.bind(this);
        this.handleGoToListViewClick = this.handleGoToListViewClick.bind(this);
        this.handleRegisterMasterCourse = this.handleRegisterMasterCourse.bind(this);
        this.onTreeDataChange = this.onTreeDataChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.countryLoaded) {
            this.props.getCountries();
        }
        if (this.props.currentView === 'sectionDetails') {
            this.props.updateTreeData();
        }
    }

    handleCurriculumTypeOnChange = (collectionName, key) => {
        this.props.changeCurriculumType(key);
        if (key === GLOBAL_CURRICULUM_ID || key === COUNTRY_CURRICULUM_ID) {
            this.props.getPublications({ accessStatus: key });
        }
    }

    handleCountryOnChange = (collectionName, key) => {
        this.props.changeCountry(key);
        this.props.getStatesByCountry(key);
    };

    handleStateOnChange = (collectionName, key) => {
        this.props.changeState(key);
    };

    handlePublicationOnChange = (collectionName, key) => {
        this.props.changePublication(key);
        this.props.getDocumentsByPublication(key);
    };

    handleDocumentOnChange = (collectionName, key) => {
        this.props.changeDocument(key);
        this.props.getSectionsByDocument(key);
    };

    handleOnSectionNameClick = (event, sectionId) => {
        event.preventDefault();
        this.props.getSectionDetails(sectionId);
    };

    handleGoToListViewClick = () => {
        this.props.loadSectionList();
    };

    handleRegisterMasterCourse = () => {
        this.props.registerMasterCourse(this.props.selectedSectionDetail.sectionId, true);
    };

    onTreeDataChange = () => {
        this.props.updateTreeData();
    };

    filterDocuments() {
        const documents = this.props.documents;
        return documents.map(doc => ({ key: doc.id, value: `${doc.name} (${doc.adoptionYear})` }));
    }

    render() {
        const publications = filterPublications({
            publications: this.props.publications,
            selectedCountry: this.props.selectedCountry,
            selectedState: this.props.selectedState
        });
        const documents = this.filterDocuments();
        return (
            <CurriculumList
                countries={this.props.countries}
                currentView={this.props.currentView}
                curriculumType={this.props.curriculumType}
                documents={documents}
                handleCountryOnChange={this.handleCountryOnChange}
                handleDocumentOnChange={this.handleDocumentOnChange}
                handleGoToListViewClick={this.handleGoToListViewClick}
                handleOnSectionNameClick={this.handleOnSectionNameClick}
                handlePublicationOnChange={this.handlePublicationOnChange}
                handleRegisterMasterCourse={this.handleRegisterMasterCourse}
                handleCurriculumTypeOnChange={this.handleCurriculumTypeOnChange}
                handleStateOnChange={this.handleStateOnChange}
                onTreeDataChange={this.onTreeDataChange}
                publications={publications}
                sections={this.props.sections}
                selectedCountry={this.props.selectedCountry}
                selectedDocument={this.props.selectedDocument}
                selectedPublication={this.props.selectedPublication}
                selectedSectionDetail={this.props.selectedSectionDetail}
                selectedState={this.props.selectedState}
                states={this.props.states}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state,
        countries: state.curriculumList.countries,
        countryLoaded: state.curriculumList.countryLoaded,
        publications: state.curriculumList.publications,
        publicationLoaded: state.curriculumList.publicationLoaded,
        documents: state.curriculumList.documents,
        sections: state.curriculumList.sections,
        selectedCountry: state.curriculumList.selectedCountry,
        states: state.curriculumList.states,
        selectedState: state.curriculumList.selectedState,
        selectedPublication: state.curriculumList.selectedPublication,
        selectedDocument: state.curriculumList.selectedDocument,
        selectedSectionDetail: state.curriculumList.selectedSectionDetail,
        currentView: state.curriculumList.currentView,
        curriculumType: state.curriculumList.curriculumType
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCountries,
        changeCountry,
        getStatesByCountry,
        changeState,
        changePublication,
        changeDocument,
        getDocumentsByPublication,
        getSectionsByDocument,
        getSectionDetails,
        loadSectionList,
        updateTreeData,
        registerMasterCourse,
        changeCurriculumType,
        getPublications
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CurriculumListContainer));



// WEBPACK FOOTER //
// ./app/containers/curriculum-list/index.js